// Modo privacidade: quando ativo, todos os valores monetários viram "R$ ••••"
// O flag é módulo-level; o re-render é disparado pelo estado privacyMode do AppContext
let privacyOn = false;
export const setPrivacyMode = (on) => { privacyOn = !!on; };

export const formatCurrency = (value) => {
  if (privacyOn) return 'R$ ••••';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
};

// Formata na moeda da conta/transação — 'USD' → "US$ 2,40", resto → "R$ 2,40"
export const formatMoney = (value, currency) => {
  if (currency !== 'USD') return formatCurrency(value);
  if (privacyOn) return 'US$ ••••';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD' }).format(value);
};

// 'YYYY-MM-DD' puro o JS interpreta como meia-noite em UTC — no Brasil (UTC-3)
// isso vira o DIA ANTERIOR na hora de exibir. Trata data pura como data local.
const parseDate = (date) => (
  typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)
    ? new Date(`${date}T00:00:00`)
    : new Date(date)
);

export const formatDate = (date) => {
  if (!date) return '-';
  const d = parseDate(date);
  if (isNaN(d.getTime())) return '-';
  return new Intl.DateTimeFormat('pt-BR').format(d);
};

export const formatMonth = (date) =>
  new Intl.DateTimeFormat('pt-BR', { month: 'long', year: 'numeric' }).format(parseDate(date));

export const monthNames = [
  'Janeiro','Fevereiro','Março','Abril','Maio','Junho',
  'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'
];

export const shortMonths = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
